import { define, html, Component } from "hybrids";

export interface VBroadcastPeopleSection {
  name: string;
}

export default define<VBroadcastPeopleSection>({
  tag: "v-broadcast-people-section",
  name: "",
  render: ({ name }) => html`
    <v-broadcast-people-header>${name}</v-broadcast-people-header>
    <section>
      <slot></slot>
    </section>
  `.css`
    :host {
      display: block;
    }

    :host(:last-child) {
      border-bottom: none;
      margin-bottom: 0;
    }

    v-broadcast-people-header {
      margin-bottom: 16px;
    }

    section {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
      grid-gap: 12px;
    }

    @media (min-width: 931px) {
      section {
        grid-gap: 20px;
      }
    }
  `,
});
